export default [
  {
    title: 'اطلاعات پایه',
    icon: 'bx bxs-dashboard',
    children: [
      {
        title: 'سوالات متداول',
        route: { name: 'faq' },
        resource: 'FaqManager',
        action: 'show',
      },
      {
        title: 'دسته بندی سوال',
        route: { name: 'faqcategory' },
        resource: 'FaqManager',
        action: 'show',
      },
      {
        title: 'بیماری ها',
        route: { name: 'sickness' },
        resource: 'SicknessManager',
        action: 'show',
      },
      {
        title: 'دسته بندی بیماری',
        route: { name: 'sicknesscategory' },
        resource: 'SicknessManager',
        action: 'show',
      },
      {
        title: 'لینک ها',
        route: { name: 'shorturl' },
        resource: 'ShortUrlManager',
        action: 'show',
      },
      {
        title: 'محتواها',
        route: { name: 'content' },
        resource: 'ContentManager',
        action: 'show',
      },
      {
        title: 'ورژن ها',
        route: { name: 'version' },
        resource: 'VersionManager',
        action: 'show',
      },
      {
        title: 'مدیریت فایل',
        route: { name: 'fileManager' },
        resource: 'VersionManager',
        action: 'show',
      },
    ],
  },
]
